
import { useCallback } from 'react';
import { Attendee } from '@/types/attendee';

export const useAttendanceEvents = () => {
  /**
   * Dispatch an update event with vibration feedback for mobile devices
   */
  const dispatchUpdateEvent = useCallback((attendee: Attendee, timestamp: string) => {
    // Create and dispatch event
    const event = new CustomEvent('attendance-ui-update', {
      detail: {
        attendee,
        attendeeCode: attendee.code,
        timestamp,
        forceRefresh: true
      }
    });
    window.dispatchEvent(event);
    
    // Add vibration feedback if supported on mobile devices
    if (window.navigator && 'vibrate' in window.navigator) {
      if (attendee.attended) {
        // Success pattern: one long pulse
        window.navigator.vibrate(200);
      } else {
        // Undo pattern: two short pulses
        window.navigator.vibrate([100, 50, 100]);
      }
    }
    
    return true;
  }, []);
  
  /**
   * Trigger a vibration pattern based on the result type
   */
  const triggerFeedback = useCallback((type: 'success' | 'error' | 'warning' | 'info' = 'success') => {
    if (!window.navigator || !('vibrate' in window.navigator)) return;
    
    switch (type) {
      case 'success':
        window.navigator.vibrate(200);
        break;
      case 'error':
        window.navigator.vibrate([100, 50, 100, 50, 100]);
        break;
      case 'warning':
        window.navigator.vibrate([100, 50, 100]);
        break;
      case 'info':
        window.navigator.vibrate(100);
        break;
    }
  }, []);
  
  return {
    dispatchUpdateEvent,
    triggerFeedback
  };
};
